import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { stylingHelpers } from '../../designTokens';
import ColorProvider from '../chrome/ColorProvider';
import Heading from '../chrome/Heading';

const { flexCenter } = stylingHelpers;

const baseStyles = ({ theme }) => css`
  background: ${theme.component.titleBgColor} no-repeat 0 0;
  background-size: cover;
  color: ${theme.colors.white};
  width: 100%;
  min-height: 40px;
  margin: 0;
  padding ${theme.spacings.bit} ${theme.spacings.byte};
  ${flexCenter()};
`;

const sizeStyles = ({ size = 'mega' }) => {
  const sizeMap = {
    kilo: {
      minHeight: 'none',
    },
    mega: {
      minHeight: '40px',
    },
  };

  return css`
    ${sizeMap[size]};
  `;
};

const imageStyles = ({ assetUrl }) =>
  assetUrl &&
  css`
    background-image: url(${assetUrl});
  `;

const Container = styled('div')(baseStyles, sizeStyles, imageStyles);

const SectionTitle = ({ assetUrl, text, size, variant, ...headingProps }) => (
  <Container assetUrl={assetUrl} size={size}>
    <ColorProvider variant={variant}>
      <Heading as='h3' size={size} upper bold noMarginBoth {...headingProps}>
        {text}
      </Heading>
    </ColorProvider>
  </Container>
);

SectionTitle.propTypes = {
  assetUrl: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
  text: PropTypes.string,
};

SectionTitle.defaultProps = {
  text: 'This is a Section Title',
  size: 'kilo',
  variant: 'white',
};

export default SectionTitle;
